import React, { useState, useEffect } from "react";
import hazardIcon from "../../images/hazard.svg";
import recommendationIcon from "../../images/recommendation.svg";
import { Images } from "react-bootstrap-icons";
import FsLightbox from "fslightbox-react";

const ChallengeSummary = ({ challenges }) => {
  // Lightbox state
  const [lightboxToggler, setLightboxToggler] = useState(false);
  const [currentImages, setCurrentImages] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [key, setKey] = useState(0);

  useEffect(() => {
    if (currentImages.length > 0) {
      setLightboxToggler(true);
    }
  }, [key, currentImageIndex, currentImages.length]);

  // If no challenges, don't render the section at all
  if (!challenges || challenges.length === 0) {
    return null;
  }

  const safetyCount = challenges.filter((c) => c.concern_level === 2).length;
  const recommendationCount = challenges.filter(
    (c) => c.concern_level === 1
  ).length;

  const openLightbox = (images, index) => {
    setLightboxToggler(false);
    setCurrentImages(images);
    setCurrentImageIndex(index);
    setKey((prev) => prev + 1);
  };

  return (
    <div className="challenge-summary-container" id="challenge-summary-section">
      <h1 className="challenge-summary-title">Challenge Summary</h1>
      <div className="challenge-summary-header-description">
        This summary is not the entire report. The complete report may include
        additional information of interest or concern to you. It is strongly
        recommended that you promptly read the complete report. For information
        regarding the negotiability of any item in this report under the real
        estate purchase contract, contact your real estate agent or an attorney.
      </div>
      <div className="challenge-summary-header">
        <div className="challenge-summary-header-item">
          <img
            src={hazardIcon}
            alt="hazard"
            style={{ width: 24, height: 24 }}
          />
          <span style={{ fontWeight: 600, fontSize: 18 }}>Safety Hazard</span>
          <span style={{ fontWeight: 700, fontSize: 20, marginLeft: 4 }}>
            {safetyCount}
          </span>
        </div>
        <div className="challenge-summary-header-item">
          <img
            src={recommendationIcon}
            alt="recommendation"
            style={{ width: 24, height: 24 }}
          />
          <span style={{ fontWeight: 600, fontSize: 18 }}>Recommendation</span>
          <span style={{ fontWeight: 700, fontSize: 20, marginLeft: 4 }}>
            {recommendationCount}
          </span>
        </div>
      </div>
      <div className="challenge-summary-list">
        {(challenges || []).map((challenge, idx) => {
          const isHazard = challenge.concern_level === 2;
          const imageCount = challenge.images?.length || 0;
          const thumbnail = challenge.images?.[0]?.presigned_url;
          const images =
            challenge.images?.map((img) => img.presigned_url) || [];
          return (
            <div
              key={challenge.id || idx}
              className="challenge-summary-row"
              style={
                idx === challenges.length - 1 ? { borderBottom: "none" } : {}
              }
              onClick={() => {
                let el = document.getElementById(challenge.id);
                if (el) {
                  const itemWrapper = el.querySelector(".item-wrapper");
                  if (itemWrapper) el = itemWrapper;
                  el.scrollIntoView({ behavior: "smooth", block: "start" });
                }
              }}
            >
              {/* Left icon */}
              <div className="challenge-summary-icon">
                {isHazard ? (
                  <img
                    src={hazardIcon}
                    alt="hazard"
                    style={{ width: 24, height: 24 }}
                  />
                ) : (
                  <img
                    src={recommendationIcon}
                    alt="recommendation"
                    style={{ width: 24, height: 24 }}
                  />
                )}
              </div>
              {/* Content */}
              <div className="challenge-summary-content">
                <div className="challenge-summary-name">{challenge.name}</div>
                <div className="challenge-summary-section">
                  {`${challenge.section} / ${challenge.subsection}`}
                </div>
                <div className="challenge-summary-description">
                  {challenge.description}
                </div>
              </div>
              {/* Right thumbnail and image count */}
              <div className="challenge-summary-thumbnail-col">
                <div
                  className="challenge-summary-thumbnail-box"
                  style={{ cursor: images.length > 0 ? "pointer" : "default" }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (images.length > 0) openLightbox(images, 0);
                  }}
                >
                  <img
                    src={thumbnail}
                    alt="thumbnail"
                    className="challenge-summary-thumbnail"
                  />
                  {imageCount > 2 && (
                    <div className="challenge-summary-image-count">
                      <Images width="16" height="16" />
                      {imageCount}
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <FsLightbox
        toggler={lightboxToggler}
        sources={currentImages}
        sourceIndex={currentImageIndex}
        type="image"
        key={key}
      />
    </div>
  );
};

export default ChallengeSummary;
